import { renderLucideIcon } from '../utils/lucide-icons.js'

function renderRadarExitAction(label) {
  return '<div class="wc-radar-exit-action" data-radar-exit-action>' +
    '<button type="button" class="wc-radar-exit-button" aria-label="' + escapeHtml(label || 'Quitter Radar') + '">' +
      renderLucideIcon('x') + '<span>' + escapeHtml(label || 'Quitter Radar') + '</span>' +
    '</button>' +
  '</div>'
}

function bindRadarExitAction(root, handlers) {
  if (!root || !handlers || typeof handlers.onExit !== 'function') return
  var button = root.querySelector ? root.querySelector('[data-radar-exit-action] button') : null
  if (!button) return
  button.addEventListener('click', function () {
    if (button.disabled) return
    button.disabled = true
    handlers.onExit()
  })
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { bindRadarExitAction, renderRadarExitAction }
